import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerifyNewPasswordComponent } from './verify-new-password/verify-new-password.component';
import { VerifyUserComponent } from './verify-user/verify-user.component';
import { LegalComponent } from './legal/legal.component';
import { FirstTimeLoginComponent } from './first-time-login/first-time-login.component';
import { PasswordValidationPanelComponent } from './password-validation/password-validation-panel.component';
import { MFAVerificationComponent } from './mfa-verification/mfa-verification.component';

export const components = [
  LoginComponent,
  SignupComponent,
  ResetPasswordComponent,
  VerifyNewPasswordComponent,
  VerifyUserComponent,
  FirstTimeLoginComponent,
  LegalComponent,
  PasswordValidationPanelComponent,
  MFAVerificationComponent
];
